export const ApplyCar = [
  {
    path: "Car",
    name: "Car",
    meta: {
      title: "专车认证"
    },
    component: () => import("@/views/sidebar/itemFrame.vue"),
    children: [
      {
        path: "Certification",
        name: "Certification",
        meta: {
          title: "专车认证"
        },
        component: () => import("@/views/apply/carCertification/index")
      },
      {
        path: "Certification_info",
        name: "Certification_info",
        meta: {
          title: "认证详情"
        },
        component: () => import("@/views/apply/carCertification/info")
      }
    ]
  }
];
